import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "shared/constants/routes";
import Button from "components/Button";
import { StyledHeader } from "styles/pages/dashboard";

const Header = () => {
  const navigate = useNavigate();
  return (
    <StyledHeader>
      {/* <Button
        title={ROUTES.MY_STORES.TITLE}
        onClick={() => navigate(ROUTES.MY_STORES.LINK)}
      /> */}
      {/* <Button
        title={ROUTES.ORDERS.TITLE}
        onClick={() => navigate(ROUTES.ORDERS.LINK)}
      /> */}
      {/* <Button
        title={ROUTES.CATALOG.TITLE}
        onClick={() => navigate(ROUTES.CATALOG.LINK)}
      />
      <Button
        title={ROUTES.MY_STORES_PRODUCTS.TITLE}
        onClick={() => navigate(ROUTES.MY_STORES_PRODUCTS.LINK)}
      />
      <Button
        title={ROUTES.BACKGROUND_BURNER.TITLE}
        onClick={() => navigate(ROUTES.BACKGROUND_BURNER.LINK)}
      />
      <Button
        title={ROUTES.USER_SALES_REPORT.TITLE}
        onClick={() => navigate(ROUTES.USER_SALES_REPORT.LINK)}
      />
      <Button
        title={ROUTES.INVENTORY.TITLE}
        onClick={() => navigate(ROUTES.INVENTORY.LINK)}
      /> */}

      <Button
        title="Order DTF Transfers"
        onClick={() => navigate(ROUTES.DTF_TRANSFERS.LINK)}
      />

      <Button
        title={ROUTES.DTF_TRANSFERS_GANG_SHEET.TITLE}
        onClick={() => navigate(ROUTES.DTF_TRANSFERS_GANG_SHEET.LINK)}
      />

      <Button
        title={ROUTES.DTF_ORDERS.TITLE}
        onClick={() => navigate(ROUTES.DTF_ORDERS.LINK)}
      />

      <Button
        title={ROUTES.ACCOUNT_SETTINGS.TITLE}
        onClick={() => navigate(ROUTES.ACCOUNT_SETTINGS.LINK)}
      />
    </StyledHeader>
  );
};

export default Header;
